import Sortable from 'sortablejs'

/** 素材横向列表拖拽排序（适配微信浏览器触摸） */
export const MP_LIST_SORTABLE_OPTIONS = {
  animation: 180,
  delay: 300,
  delayOnTouchOnly: true,
  touchStartThreshold: 5,
  filter: '.delete-button',
  preventOnFilter: true,
  forceFallback: true,
  fallbackTolerance: 5,
}

export function reorderMpList(list, oldIndex, newIndex) {
  if (!Array.isArray(list) || oldIndex == null || newIndex == null || oldIndex === newIndex) {
    return false
  }
  if (oldIndex >= list.length) return false

  const moved = list.splice(oldIndex, 1)[0]
  list.splice(newIndex, 0, moved)
  list.forEach((row, i) => {
    if (row && typeof row === 'object' && 'sort' in row) {
      row.sort = i
    }
  })
  return true
}

export function destroySortableInstance(instance) {
  if (!instance) return
  try {
    instance.destroy()
  } catch (e) {
    /* ignore */
  }
}

/**
 * @param {HTMLElement} el
 * @param {{ draggable: string, onReorder: (oldIndex: number, newIndex: number) => void, sortableOptions?: object }} options
 */
export function createMpListSortable(el, { draggable, onReorder, sortableOptions = {} }) {
  return Sortable.create(el, {
    ...MP_LIST_SORTABLE_OPTIONS,
    ...sortableOptions,
    draggable,
    onEnd(evt) {
      const { oldIndex, newIndex } = evt
      if (oldIndex == null || newIndex == null || oldIndex === newIndex) return
      onReorder(oldIndex, newIndex)
    },
  })
}
